import React from 'react';

export const MuiNe = {
    "name": "Mui Ne",
    "link": "mui-ne",
    "country": "Vietnam",
    "continent": "Asia",
    "thumb": "https://live.staticflickr.com/65535/50380448346_47a671b138_t.jpg",
    "image": "https://live.staticflickr.com/65535/50380448346_695ac01603_o.jpg",
    "caption": "The mini desert city",

    "description": "Mui Ne is a coastal town about 5 hours north of Ho Chi Minh City. It was once considered one of the poor wards on the city of Phan Thiet, due to its remote location and the unusual presence of a desert in the middle of town. But those old days are long gone. Now, it is one of the most famous destinations in the south of Vietnam, for locals and foreigners alike. At the same time, it still does not have the same quantity of tourists as other places in Vietnam, which makes it quite relaxing and peaceful, and consequently accommodation prices are lower.",

    "nrDays": <p>If you are short in time, maybe one day is enough to see the city. However the recommended time for a stay here is at least <b>2 days</b>, to enjoy the night life that this city as to offer.
              </p>,

    "whenVisit": <p>The best time to visit Mui Ne is from <b>November to January</b>. This is a hot zone of the country and the temperature could get to some huge values in the rainfall months.
                 </p>,

    "mobility": <p>Moving here is quite similar as the other remote Vietnam zones. Renting a motorcycle is always an option for good prices. Also, you can use Grab.
                <br/><br/>
                Getting to Mui Ne will depend from where you come. If you are arriving from Ho Chi Minh City we recommend the night bus or a train. From Dalat, the best option is bus.
                It will take almost 5 hours and costs around 5$. If you want to make some stops get a motorcycle instead of a bus. From Nha Trang you will have similar options as Dalat.
                </p>,

    "safety": <p>Mui Ne is a safe city to travel in. As in other places in Vietnam, scams are the most common issue that you will probably find here. Keep your personal belongings close to you, mostly at night.
            </p>,

    "itinerary": {
        "description": "As described before, we recommend 2 days to see the city. Mui Ne is a hidden gem full of surprises. You can easily come across a random uncharted beautiful landscape or discover a not-yet-popular nice local bar on a less-traversed street. However, here it is our recommended itinerary.",
        "days": [
            {
                "description":
                    <p>
                        Start your day with a visit to the <b>Mui Ne Fishing Village</b> and the <b>Morning Market</b>. Before lunch make a quick stop at <b>Po Sha Inu Cham Towers</b>. After a morning full of excitement get a local specialty for lunch, at Vietnam Home Restaurant. We recommend you try the Seven Dishes from Iguana. In the afternoon, embrace the beauty of the <b>Fairy Stream</b>. You will spend a good few hours here, and will get some nice pictures.
                        For dinner you should try the signature dish of Mui Ne, the <b>Hot Pot Feast</b>. At night you really should visit and enjoy the party night of the <a href="https://www.facebook.com/DragonBeachMuiNe/" target="_blank" rel="noopener noreferrer">Dragon Beach Bar</a>.
                    </p>,
                "image": "https://live.staticflickr.com/65535/50502946876_8975fa7289_o.jpg",
                "caption": "Mui Ne Fishing Village."
            },
            {
                "description": <p>
                    We suggest to visit the <b>Silky Sand Dunes</b> in the early morning. It is a place that rarely is without tourists and in the early hours you will have a nice landscape without so many people. For lunch and afternoon we recommend you take some time to enjoy the street food and relax in the beautiful beaches that Mui Ne has to offer.
                </p>,
                "image": "https://live.staticflickr.com/65535/50502229178_8ce21315f3_o.jpg",
                "caption": "Mui Ne Beach."
            }
        ]
    },

    "highlights": [
        {
            "name": "Mui Ne Fishing Village",
            "description": "Take an early ride to this village to get a glimpse of the local fishing life. The smell on the place is not great, but the view of all the colorful fishing boats and the sunrise are certainly worth the time spent. In the market area, you will see fish being sold to the restaurant owners, traders and so on.",
            "image": "https://live.staticflickr.com/65535/50503100027_3c1fa3673a_o.jpg"
        },
        {
            "name": "Fairy Stream",
            "description": "On both sides of this path, the stream is surrounded by colorful limestone formations and greenery. The mix of colors makes this look a little like a fairy tail place. Make the path all the way on foot and in the end you will find a small but beautiful waterfall.",
            "image": "https://live.staticflickr.com/65535/50503099997_009c2954d7_o.jpg"
        },
        {
            "name": "White and Red Sand Dunes",
            "description": "These dunes are the main attraction of Mui Ne. You can rent a bike here and explore all the areas of the place. Enjoy the sunset here, with a magnific mix of colors on the floor.",
            "image": "https://live.staticflickr.com/65535/50502229078_dc0cb200cb_o.jpg"
        }
    ],

    "food": {
        "description": <p>

            </p>,
        "restaurants": [
            {
                "name": "Goa Indian Restaurant",
                "description": "Fast and friendly service, this restaurant serves you with good Indian cuisine.",
                "price": 1,
                "image": "https://live.staticflickr.com/65535/50503099932_2b3475029c_o.jpg"
            },
            {
                "name": "Strawy Restaurant",
                "description": "With a lovely view to the sea and good food, this restaurant is an attractive option.",
                "price": 2,
                "image": "https://live.staticflickr.com/65535/50503099867_43abfb2338_o.jpg"
            },
            {
                "name": "Lacheln Restaurant",
                "description": "Nice grilled food, good music environment and affordable prices makes this a good selection.",
                "price": 2,
                "image": "https://live.staticflickr.com/65535/50502228958_8072284d2d_o.jpg"
            },
            {
                "name": "Modjo Bar & Restaurant",
                "description": "Cheap options, most of them related to occidental cuisine make this a good choice if you want to taste this type of food.",
                "price": 2,
                "image": "https://live.staticflickr.com/65535/50502228903_160edf90f5_o.jpg"
            }
        ]
    },

    "stay": {
        "description": "Mui Ne is a very touristic spot, with a huge option on hotels and resorts to stay. We recommend some stays we think are good options for a night in the city.",
        "budget": [
            {
                "name": "La Marina Boutique Hotel & Spa",
                "description": "Situated in the centre of Mui Ne Village with a view to the ocean and free WiFi, it is a very good budget option.",
                "image": "https://live.staticflickr.com/65535/50503099817_6772e41b45_o.jpg",
                "link": "/"
            }
        ],
        "mid": [
            {
                "name": "Full Moon Beach Resort",
                "description": "With an indoor pool with salty water this Resort located close to the Mui Ne beach is a nice choice. Comes with included breakfast.",
                "image": "https://live.staticflickr.com/65535/50502946571_85cda3dff0_o.jpg",
                "link": "/"
            }
        ],
        "high": [
            {
                "name": "Muine Bay Resort",
                "description": "Only two steps from the beach, Muine Bay Resort provides large rooms with private balconies. They also have an indoor swimming pool with a bar. The breakfast is included.",
                "image": "https://live.staticflickr.com/65535/50502946546_2d8d684aeb_o.jpg",
                "link": "/"
            }
        ]
    }
}
